module.exports = __webpack_public_path__ + "static/media/heart.15c54366.svg";